import EventBus from '@/EventBus';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';
import { findObjectById, getPropertyApplyTargets, isSvgStrokeObject } from '@/components/Canvas/utils/groupHelpers';

export default {
  methods: {
    getShapePropertyTargets() {
      const list = this.contentList || this.objectList;
      const topLevel = (typeof this.getSelectedTopLevelObjects === 'function')
        ? this.getSelectedTopLevelObjects()
        : null;
      return getPropertyApplyTargets(
        list,
        this.selectedObjectsList,
        this.activeObject,
        topLevel,
      );
    },
    findActiveObjectOnCanvas(objectId) {
      return findObjectById(this.contentList, objectId)
        || findObjectById(this.objectList, objectId);
    },
    changeShapeColor(color, objectId = '') {
      const targets = this.getShapePropertyTargets();
      const shapeIds = new Set(
        targets
          .filter(object => object && object.Id)
          .map(object => object.Id),
      );
      if (objectId) { shapeIds.add(objectId); }
      if (!shapeIds.size) { return; }
      shapeIds.forEach((id) => {
        this.changeShapeColorById(color, id);
      });
      this.addIntoPageWiseUndoRedoArray_MixinFun('change shape color');
    },
    changeShapeColorBk(color) { // deleteable temporary function backup
      if (this.activeObject != null && (this.activeObject.type === 'shape' || this.activeObject.ImageType === 'SVGImage') && this.activeObject.isGradient) {
        const alpha                                                         = parseFloat(color.split(',')[3]);
        const selectedObject                                                = this.activeObject;
        selectedObject.gradient.colors.find(color => color.isSelected).rgba = alpha > 0 ? color : 'rgba(255, 255, 255, 0)';
        EventBus.$emit(ApplicationEventTypes.LayerPanelEvents.UPDATE_DATA_ON_LAYER_SWAP, this.contentList);

        if (selectedObject.ImageType === 'SVGImage') {
          EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.CHANGE_SVG_FILL_COLOR);
        }
      }

      if (this.activeObject != null && (this.activeObject.type === 'shape')) {
        this.activeObject.DefaultColor = color;
        EventBus.$emit('updateProductColor');
      }

      if (this.activeObject != null && this.activeObject.type === 'shape' && this.activeObject.shapeType === 'svgShapes') {
        const svgElement = document.getElementById(this.activeObject.Id).firstChild.firstChild;
        svgElement && svgElement.setAttribute('fill', color);
        this.activeObject.svgContent = svgElement.outerHTML;
      }
      this.addIntoPageWiseUndoRedoArray_MixinFun('change shape color');
    },
    async changeShapeColorById(color, objectId) {
      const alpha          = parseFloat(color.split(',')[3]);
      const selectedObject = this.findActiveObjectOnCanvas(objectId);
      if (!selectedObject) { return; }
      if (selectedObject.isGradient && selectedObject.gradient && selectedObject.gradient.colors) {
        const selectedStop = selectedObject.gradient.colors.find(clr => clr.isSelected);
        if (selectedStop) {
          this.$set(selectedStop, 'rgba', alpha > 0 ? color : 'rgba(255, 255, 255, 0)');
        }
        EventBus.$emit(ApplicationEventTypes.LayerPanelEvents.UPDATE_DATA_ON_LAYER_SWAP, this.contentList);
        if (isSvgStrokeObject(selectedObject)) {
          EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.CHANGE_SVG_FILL_COLOR, null, selectedObject.Id);
        }
      } else {
        if ((selectedObject.type === 'image') && (selectedObject.ImageType === 'SVGImage' || selectedObject.ImageType.indexOf('FDICText') !== -1 || selectedObject.ImageType.indexOf('FDICLogo') !== -1)) {
          EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.CHANGE_SVG_FILL_COLOR, color, selectedObject.Id);
        }

        if (selectedObject.type === 'shape') {
          this.$set(selectedObject, 'DefaultColor', color);
        }

        if ((selectedObject.type === 'shape' && selectedObject.shapeType === 'svgShapes')
          || (selectedObject.type === 'image' && selectedObject.ImageType.indexOf('FDICText') !== -1)
          || (selectedObject.type === 'image' && selectedObject.ImageType.indexOf('FDICLogo') !== -1)
        ) {
          const host = document.getElementById(selectedObject.Id);
          const svgElement = host && host.firstChild && host.firstChild.firstChild;
          if (svgElement) {
            svgElement.setAttribute('fill', color);
            if (svgElement.parentNode) {
              svgElement.parentNode.style.fill = 'none';
            }
            selectedObject.svgContent = svgElement.outerHTML;
          }
        }
      }

      const boxes = document.querySelectorAll('.effect-box');
      boxes.forEach((box) => {
        box.style.background = color;
      });
    },
    changeShapeStrokeBk(color) {
      if (this.activeObject != null && (this.activeObject.type === 'shape')) {
        this.activeObject.StrokeColor = color;
        EventBus.$emit('updateProductColor');
      }

      console.log('Changing stroke');
      if (this.activeObject != null && this.activeObject.type === 'shape' && this.activeObject.shapeType === 'svgShapes') {
        const svgElement = document.getElementById(this.activeObject.Id).firstChild.firstChild;
        const lines      = svgElement.querySelectorAll('line, path, rect, ellipse, polygon');
        if (lines.length) {
          for (let lineIndex = 0; lineIndex < lines.length; lineIndex++) {
            lines[lineIndex].style.stroke = color;
          }
        }

        this.activeObject.svgContent = svgElement.outerHTML;
      }
      this.addIntoPageWiseUndoRedoArray_MixinFun('change shape color');
    },
    changeShapeStroke(color, objectId = '') {
      const targets = this.getShapePropertyTargets();
      const shapeIds = new Set(
        targets
          .filter(object => object && object.type === 'shape' && object.Id)
          .map(object => object.Id),
      );
      if (objectId) { shapeIds.add(objectId); }

      if (!shapeIds.size) { return; }
      shapeIds.forEach((id) => {
        this.changeShapeStrokeById(color, id);
      });
      this.addIntoPageWiseUndoRedoArray_MixinFun('change shape color');
    },
    applyShapeStroke(selectedObject, color) {
      if (!selectedObject || selectedObject.type !== 'shape') { return; }
      const host = document.getElementById(selectedObject.Id)
        || document.querySelector(`.canvas-main-html-container [id='${selectedObject.Id}']`);
      if (!host) { return; }

      const paintables = host.querySelectorAll('line, path, rect, ellipse, polygon');
      paintables.forEach((el) => {
        el.style.stroke = color;
        el.setAttribute('stroke', color);
      });

      if (selectedObject.shapeType === 'svgShapes') {
        const svgElement = host.querySelector('svg') || (host.firstChild && host.firstChild.firstChild);
        if (svgElement) {
          this.$set(selectedObject, 'svgContent', svgElement.outerHTML);
        }
      }
    },
    changeShapeStrokeById(color, objectId) {
      const selectedObject = this.findActiveObjectOnCanvas(objectId);
      if (!selectedObject || selectedObject.type !== 'shape') { return; }

      this.$set(selectedObject, 'StrokeColor', color);
      this.applyShapeStroke(selectedObject, color);
      this.$nextTick(() => {
        this.applyShapeStroke(selectedObject, color);
      });
      EventBus.$emit('updateProductColor');

      const boxes = document.querySelectorAll('.effect-box');
      boxes.forEach((box) => {
        box.style.background = color;
      });
    },
  },
};
